import jackpotsvg from '../../styles/img/jackpottag.svg';
import jackpoticon from '../../styles/img/jackpot.svg';
import clsx from 'clsx';

export default function PikkoJackpotTag({ price = null, icon = false, text = ''}) {
    return (
        <div
            className={clsx(
                "relative w-fit h-full flex justify-center text-xl geomanistMedium font-white gap-2 items-center",
                text ? "rounded-xl px-8 py-3" : "rounded-[6px] px-[10px] py-[6px]"
            )}
            style={{ backgroundImage: `url(${jackpotsvg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
        >
            {icon && <img src={jackpoticon} alt="jackpot" className={clsx(text ? "w-5 h-5" : "w-[14px] h-[14px]")} />}
            <div className='flex items-center justify-center gap-[0.4em]'>
                <p className={clsx("geomanistMedium text-white leading-none", text ? "text-[14px]" : "text-[13px]")}> {price}</p>
                {text && <p className="geomanistBook text-white text-[14px] whitespace-nowrap leading-none"> {text}</p>}
            </div>
        </div>
    )
}
